import React from "react";
import "../Styles/index.scss";

interface Props {
  tableHeader: any[];
  extraHeader?: boolean;
  textCenter?: boolean;
  rowSpan?: boolean;
  type?: string;
}
const GstTableHeader = ({
  tableHeader = [],
  extraHeader,
  textCenter,
  type,
  rowSpan,
}: Props) => {
  return (
    <>
      <tr>
        {tableHeader.map((item, index) => {
          if (item) {
            return (
              <th
                className={`${textCenter ? "text-center" : null} ${
                  type ? "gstr_head" : "name"
                }  th-lg text-nowrap `}
                style={{ backgroundColor: type ? "#f3f6f8" : "" , width:item?.width ? item?.width : ""}}
                key={item?.value}
              >
                {item?.label}
              </th>
            );
          } else {
            return null;
          }
        })}
        {extraHeader && <th></th>}
      </tr>
    </>
  );
};

export default GstTableHeader;
